/* eslint-disable max-len */
import React from "react";
import { useNavigate } from "react-router-dom";

const LedgerTable = ({mainHeading, 
    ledgerData,  
    totalBalance,
    totalBalanceType,
    searchParams,
    netProfit,
    setSearchParams,
    setStockTableLoading,
    mainPath, 
    setPageType}) => {

    const navigate = useNavigate()
    
    const subLegderHandler = (id, hasChild, item,  dataName, itemName) => {
        if(!hasChild){
            return
        } else {
            let params = Object?.fromEntries(searchParams);
            if(id === 'group'){
                if (item?.is_inventory && mainPath === 'p & l/expenses' ) {
                    params.type = 'opening-stock'
                    setPageType('opening-stock');
                    setStockTableLoading(true)
                } else if(item?.is_inventory && mainPath === 'p & l/income'){
                    params.type ='closing-stock'
                    setPageType('closing-stock');
                    setStockTableLoading(true)
                }else {
                    params.type ='mainGroup';
                    setPageType('mainGroup');
                }
                // Update type parameter in params based on item properties
                setSearchParams({...params});

                // Update searchParams and navigate to the appropriate URL
                navigate(`/financial-statements/profit-and-loss-sheet/${mainPath}/${
                    encodeURIComponent(dataName)}${
                    Object.keys(params).length === 0 ? '' : `?${new URLSearchParams(params).toString()}`}`);  
            }
        }
    }

    /**
     * The function `displayBalance` formats and displays a balance amount based on its type and value.
     * @returns The function `displayBalance` returns the formatted balance based on the type of
     * transaction. If the type is "cr" (credit) and the balance is negative, it returns the absolute value
     * of the balance with a negative sign in front. Otherwise, it returns the balance formatted with two
     * decimal places.
     */
    const displayBalance = (type, balance) => {
        if (type === 'net_profit'){
            if (balance < 0) {
                return `(-)${Math.abs(parseFloat(balance)).toFixed(2)}`;
            }
        }
        if(mainHeading === 'Expenses'){
            if (type === "cr" && balance !== 0) {
                return `(-)${Math.abs(parseFloat(balance)).toFixed(2)}`;
            }
            return parseFloat(balance).toFixed(2);
        }
        if(mainHeading === 'Income'){
            if (type === "dr" && balance !== 0) {
                return `(-)${Math.abs(parseFloat(balance)).toFixed(2)}`;
            }
            return parseFloat(balance).toFixed(2);
        }
    };

    return (
        <div className="relative min-h-full">
            <h2 className="px-[10px] h-[36px] flex justify-between items-center text-lg font-semibold text-[#106EB4] bg-[#EEF7FE]">{mainHeading}</h2>
            <div className="pb-10">
                {ledgerData?.map((data, index) => (
                    <div key={index+data} className="py-[8px]">
                        <div className={`flex justify-between px-[12px] ${data?.name === 'Net Profit' ? 'pt-[40px] pb-[9px]': ''}`}>
                            <p className={`break-all ${data?.name === 'Net Profit' ? '' : 'hover:text-[#106EB4]'} ${(data?.has_child) ? 'cursor-pointer' : ''}`} 
                                onClick={() => subLegderHandler('group', data?.has_child, data, data?.name)}
                                id={data?.name+'_'+index}>
                                {data?.name}
                            </p>
                            <p className={`min-w-[120px] pl-2 text-end ${data?.name === 'Net Profit' ? '' : 'hover:text-[#106EB4]'} ${(data?.has_child) ? 'cursor-pointer' : ''}`} 
                                onClick={() => subLegderHandler('group', data?.has_child, data, data?.name)}
                                id={data?.name+'_'+index+'_closing_stock'}>
                                {displayBalance(data?.type, data?.balance)}
                            </p>
                        </div>
                    </div>
                ))}
                {netProfit !== undefined && <div>
                    <div className={`flex justify-between px-[12px] py-[9px] font-semibold pt-[40px] pb-[9px]`}>
                        <p className={`break-all`} 
                            id={'net_profit'}>
                            Net Profit
                        </p>
                        <p className={`min-w-[120px] pl-2 text-end`} 
                            id={'net_profit_balance'}>
                            {displayBalance('net_profit', netProfit)}
                        </p>
                    </div>
                </div>}
            </div>
            <div className="absolute bottom-0 text-base left-0 w-full px-[10px] h-[36px] font-semibold bg-[#EEF7FE] flex justify-between items-center">
                <p>Total</p>
                <p>{displayBalance(totalBalanceType, totalBalance)}</p>
            </div>
        </div>
    )
}

export default LedgerTable;